<template>
  <div class="border border-orange-50 box-shadow px-6 py-4 rounded">
    <section v-if="!loading">
      <h1 class="font-medium mb-6 sm:mb-5 text-black">個人資料</h1>
      <div v-if="user?.enablePickupCode" class="flex flex-col mb-4">
        <div class="flex items-center sm:flex-col sm:items-start">
          <label class="sm:mb-2 text-gray-500 weiby-label-width">
            專屬條碼
          </label>
          <w-button
            :disabled="!hasUserInfo"
            class="
              border-white
              hover:bg-white
              hover:border
              hover:border-primary-500
              hover:text-primary-500
              py-2
              sm:border-primary-500
              sm:w-full
              text-primary-500
            "
            variant="outline"
            @click.prevent="toggleUserQrCode()"
          >
            <span v-if="!showUserQrCode">
              展開領取條碼
              <i class="icon-chevron-down ml-2 text-primary-500" />
            </span>
            <span v-else>收合領取條碼 <i class="icon-chevron-up ml-2 text-primary-500" /></span>
          </w-button>
        </div>
        <canvas v-if="showUserQrCode" id="qrCode" class="ml-36 sm:mx-auto" />
      </div>
      <w-input
        :value="user.serial"
        disabled
        label="人員編號"
      />
      <w-input
        :value="user.account"
        disabled
        label="帳號"
      />
      <w-input
        v-model="form.name"
        :message="getErrorMsgs('name')"
        :show-error="hasErrorMsgs('name')"
        label="姓名"
        placeholder="姓名"
        required
        @blur="userValidator$.form.name.$touch()"
      />
      <w-input
        :value="unitText"
        disabled
        label="單位"
      />
      <w-input
        v-model="form.email"
        :message="getErrorMsgs('email')"
        :show-error="hasErrorMsgs('email')"
        label="Email"
        type="email"
        placeholder="Email"
        @blur="userValidator$.form.email.$touch()"
      />
      <w-input
        v-model="form.ext"
        :message="getErrorMsgs('ext')"
        :show-error="hasErrorMsgs('ext')"
        label="分機/電話"
        placeholder="分機/電話"
        @blur="userValidator$.form.ext.$touch()"
      />
      <w-input
        v-model="form.phone"
        :message="getErrorMsgs('phone')"
        :show-error="hasErrorMsgs('phone')"
        label="手機號碼"
        placeholder="手機號碼"
        @blur="userValidator$.form.phone.$touch()"
      />
      <div
        v-if="showSaveButton"
        class="flex items-center justify-end"
      >
        <w-button
          :disabled="saving || (userValidator$.form.$invalid && userValidator$.form.$dirty)"
          :loading="saving"
          @click="save"
        >
          <span>
            儲存
          </span>
        </w-button>
      </div>
    </section>
    <w-loading v-else color="primary-500" />
  </div>
</template>

<script>
import UserInfos from './UserInfos';

export default UserInfos;
</script>

<style lang="scss" scoped>
@import 'UserInfos';
</style>
